module.exports = __webpack_public_path__ + "static/media/remy.739d8cbc.jpg";